import React, { useEffect } from "react";
import {
  List,
  ListItem,
  ListItemText,
  Button,
  Typography,
  Box,
} from "@mui/material";
import { useImpersonation } from "../../contexts/ImpersonationContext";
import { getAllUsers } from "../../services/admin-service";
import { IUser } from "../../types/user";

const UserImpersonationList: React.FC<{ onComplete: () => void }> = ({
  onComplete,
}) => {
  const { setImpersonatedUserId } = useImpersonation();

  const [allUsers, setAllUsers] = React.useState<IUser[]>([]);

  useEffect(() => {
    getAllUsers().then((res) => setAllUsers(res));

    // eslint-disable-next-line
  }, []);

  const handleImpersonate = (userId: string) => {
    setImpersonatedUserId(userId);
    window.location.reload(); // refresh so new impersonated user state applies
  };

  return (
    <Box sx={{ padding: 2 }}>
      <Typography variant="h6" gutterBottom>
        Impersonate a User
      </Typography>
      <List>
        {allUsers.map((user) => (
          <ListItem
            key={user.cognitoId}
            secondaryAction={
              <Button
                variant="contained"
                size="small"
                onClick={() => handleImpersonate(user.cognitoId)}
              >
                Impersonate
              </Button>
            }
          >
            <ListItemText
              primary={`${user.firstName} ${user.lastName}`}
              secondary={user.emailId}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default UserImpersonationList;
